<svelte:options runes={true} />

<script lang="ts">
  import Badge from "~/components/ui/Badge/Badge.svelte";
  import Checkbox from "~/components/ui/Checkbox/Checkbox.svelte";

  interface Props {
    value: string;
    label: string;
    count?: number;
    disabled?: boolean;
    class?: string;
  }

  let { value, label, count, disabled, class: className = "" }: Props = $props();
  const uid = $props.id();

  let checkboxEl: HTMLButtonElement | null = $state(null);
  let checked = $state(false);

  function handleClick(event: MouseEvent) {
    if (disabled || !checkboxEl || checkboxEl.contains(event.target as Node)) return;
    checkboxEl.click();
  }
</script>

<div
  class="da-checkbox-group-item {className}"
  data-checked={checked || undefined}
  data-disabled={disabled || undefined}
  role="presentation"
  onclick={handleClick}
>
  <Checkbox
    {value}
    {disabled}
    bind:checked
    bind:ref={checkboxEl}
    class="da-checkbox-group-item__checkbox"
    aria-labelledby="label-{uid}-{value}"
  />
  <span id="label-{uid}-{value}" class="da-checkbox-group-item__label">{label}</span>
  {#if count !== undefined && count !== 0}
    <Badge text={String(count)} color="charcoal" size="sm" class="da-checkbox-group-item__count" />
  {/if}
</div>

<style>
  @layer aurora {
    .da-checkbox-group-item {
      display: flex;
      align-items: center;
      gap: var(--da-space-2);
      padding: var(--da-space-px-10) var(--da-space-4);
      background: var(--da-color-brand-sand-100);
      border: 1px solid var(--da-color-brand-sand-900);
      border-radius: var(--da-radius-md);
      transition:
        background var(--da-duration-normal),
        border-color var(--da-duration-normal),
        color var(--da-duration-normal),
        border-radius var(--da-duration-normal);
      cursor: pointer;
      user-select: none;
    }

    .da-checkbox-group-item:has(:global(:focus-visible)) {
      outline: 2px solid var(--da-color-charcoal-500);
      outline-offset: 2px;
    }

    .da-checkbox-group-item:hover:not([data-disabled]) {
      background: var(--da-color-brand-sand-700);
      border-color: var(--da-color-charcoal-300);
    }

    .da-checkbox-group-item[data-disabled] {
      background: var(--da-color-charcoal-50);
      border-color: var(--da-color-white);
      opacity: 0.6;
      cursor: not-allowed;
    }

    .da-checkbox-group-item[data-checked] {
      background: var(--da-color-brand-sand-900);
      border-color: var(--da-color-charcoal-300);
    }

    .da-checkbox-group-item__label {
      flex: 1;
      font-size: var(--da-font-size-sm);
      font-weight: var(--da-font-weight-medium);
      color: var(--da-color-charcoal-500);
    }

    .da-checkbox-group-item[data-checked] .da-checkbox-group-item__label {
      color: var(--da-color-charcoal-700);
    }

    .da-checkbox-group-item__count {
      margin-inline-start: auto;
    }
  }
</style>
